(function($) {

    let scrolling = false;
    let rates_wrapper = $('.rates-wrapper');
    let loadingRates = false, ratesLoaded = false;

    let carousel_section = $('.carousel');
    let lightSliderLoaded = false;

    let istruments = document.getElementsByClassName('lr-instr-wrapper');


    function doScrolling() {
        if (rates_wrapper.length > 0 && !loadingRates && !ratesLoaded && window.isInViewport(rates_wrapper)) {
            loadingRates = true;
            !ratesLoaded && import(/* webpackChunkName: "InstrumentsPagerates" */'./InstrumentsPagerates')
                .then(module => {
                    loadingRates = false;
                    ratesLoaded = true;
                });
        }

        if (!lightSliderLoaded && $(window).width() < 1600 && typeof window.isInViewport != 'undefined' && window.isInViewport(carousel_section) && istruments.length > 2) {
            if($('.rate-box-wrapper').length == 0) {
                lightSliderLoaded = false;
            }else{
                import(/* webpackChunkName: "lightSlider" */ '../lightSlider/lightSlider');
                lightSliderLoaded = true;
            }

        }
    }


    window.scrollingTasks.push(doScrolling);

    if($(window).width() > 620){ window.callDoScrolling = true; }


    


})(window.jQuery);